var render, staticRenderFns
import script from "./postAd.vue?vue&type=script&lang=js"
export * from "./postAd.vue?vue&type=script&lang=js"
import style0 from "./postAd.vue?vue&type=style&index=0&id=113b7684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b7684",
  null
  
)

export default component.exports